import { render, staticRenderFns } from "./SingleLayerElementSimplified.vue?vue&type=template&id=bcc59a4e&scoped=true"
import script from "./SingleLayerElementSimplified.vue?vue&type=script&lang=ts"
export * from "./SingleLayerElementSimplified.vue?vue&type=script&lang=ts"
import style0 from "./SingleLayerElementSimplified.vue?vue&type=style&index=0&id=bcc59a4e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcc59a4e",
  null
  
)

export default component.exports